import { createAsyncThunk } from '@reduxjs/toolkit';
import { IGetSecureDataRequestTextVariablesResponse } from 'services/connectwise/types';
import { getSecureDataRequestTextVariables } from 'services/secureDataSharing';

export const ThunkGetSecureDataRequestTextVariables = createAsyncThunk<
  IGetSecureDataRequestTextVariablesResponse,
  { crmId: number | undefined; psaContactId: string | undefined }
>('secureDataSharing/getTextVariables', ({ crmId, psaContactId }) =>
  getSecureDataRequestTextVariables(crmId, psaContactId).then(r => r.data),
);
